// src/components/Nav.js
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Nav.css'; // Import the CSS file

const Nav = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const families = [
        'Merimangat', 'Ephemeroptera', 'Odonata', 'Plecoptera', 'Trichoptera',
        'Lepidoptera', 'Coleoptera', 'Hemiptera Diptera Mecoptera', 'Pakurrizoret tjerë', 
        'Peshqit', 'Amfibet dhe Reptilet', 'Shpendet', 'Gjitaret'    
    ];

    const isActive = (path) => location.pathname === path;

    return (
        <nav className='nav-bar'>
            <div className='nav-container'>
                <div className='nav-logo' onClick={() => navigate('/')}>
                    <span className='logo-text'>Fauna of Kosovo</span>
                </div>
                
                <button 
                    className='mobile-menu-toggle'
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    aria-label="Toggle menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

                <ul className={`nav-list ${isMobileMenuOpen ? 'active' : ''}`}>
                    <li 
                        className={`nav-item ${isActive('/') ? 'active' : ''}`}
                        onClick={() => {
                            navigate('/');
                            setIsMobileMenuOpen(false);
                        }}
                    >
                        Home
                    </li>
                    <li 
                        className={`nav-item ${isActive('/endemic') ? 'active' : ''}`}
                        onClick={() => {
                            navigate('/endemic');
                            setIsMobileMenuOpen(false);
                        }}
                    >
                        Llojet Endemike
                    </li>
                    <li 
                        className={`nav-item ${isActive('/references') ? 'active' : ''}`}
                        onClick={() => {
                            navigate('/references');
                            setIsMobileMenuOpen(false);
                        }}
                    >
                        Referencat
                    </li>
                    <li className='nav-item dropdown'>
                        <span className='dropdown-toggle'>
                            Grupet Shtazore
                            <svg className='dropdown-arrow' width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
                                <path d="M2 4l4 4 4-4z"/>
                            </svg>
                        </span>
                        <ul className='dropdown-menu'>
                            {families.map((family, index) => (
                                <li 
                                    key={index}
                                    className='dropdown-item'
                                    onClick={() => {
                                        navigate(`/families/${family}`);
                                        setIsMobileMenuOpen(false);
                                    }}
                                >
                                    {family}
                                </li>
                            ))}
                        </ul>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Nav;
